// EntryFootnote — Einheitliche Fußzeile für öffentliche Cards/Detailseiten.
// Etappe 4.11 — Pflegeansicht ↔ öffentliche Darstellung angleichen.
//
// Reihenfolge (von oben nach unten, alles optional):
//   1. Tags (#tag #tag …)
//   2. Källa
//   3. Senast uppdaterad (Datum + ev. „uppdaterad av")
//
// Verwendung:
//   <EntryFootnote
//     taggar={item.taggar}
//     kalla={item.kalla || item.kalltext}
//     senast={item.senast_andrad || item.senast_kontrollerad}
//     uppdaterad_av={item.andrad_av}
//   />
import { Tag, BookOpen, Clock } from "lucide-react";

function formatSwedishDate(value) {
  if (!value) return null;
  // Akzeptiere "2026-06-28", ISO "2026-06-28T11:02:00Z" oder Date.
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleDateString("sv-SE", { year: "numeric", month: "long", day: "numeric" });
}

export default function EntryFootnote({
  taggar,
  kalla,
  senast,
  uppdaterad_av,
  testIdPrefix,
  className = "",
}) {
  const hasTags = false; // Build 96.23 — Tags publikt dolda. Data ligger kvar i DB, endast presentation.
  const hasKalla = typeof kalla === "string" && kalla.trim().length > 0;
  const formatted = formatSwedishDate(senast);
  const hasUpdated = !!formatted;

  if (!hasTags && !hasKalla && !hasUpdated) return null;

  return (
    <div
      data-testid={testIdPrefix ? `${testIdPrefix}-footnote` : "entry-footnote"}
      className={`mt-4 pt-3 border-t border-warm-border/50 flex flex-col gap-1.5 text-xs text-bark/75 leading-relaxed ${className}`}
    >
      {hasTags && (
        <div
          data-testid={testIdPrefix ? `${testIdPrefix}-tags` : "entry-tags"}
          className="flex flex-wrap items-center gap-1.5"
        >
          <Tag size={11} className="text-bark/55 shrink-0" />
          {taggar.map((t, i) => (
            <span
              key={i}
              className="text-[11px] text-bark/70 bg-bone-alt/60 border border-warm-border/40 px-1.5 py-0.5 rounded-sm"
            >
              #{t}
            </span>
          ))}
        </div>
      )}
      {hasKalla && (
        <div
          data-testid={testIdPrefix ? `${testIdPrefix}-kalla` : "entry-kalla"}
          className="flex items-center gap-1.5"
        >
          <BookOpen size={11} className="text-bark/55 shrink-0" />
          <span>
            <span className="text-bark/55">Källa:</span> <span className="text-bark">{kalla}</span>
          </span>
        </div>
      )}
      {hasUpdated && (
        <div
          data-testid={testIdPrefix ? `${testIdPrefix}-uppdaterad` : "entry-uppdaterad"}
          className="flex items-center gap-1.5"
        >
          <Clock size={11} className="text-bark/55 shrink-0" />
          <span>
            <span className="text-bark/55">Senast uppdaterad:</span>{" "}
            <span className="text-bark">{formatted}</span>
            {uppdaterad_av && (
              <span className="text-bark/55"> · av {uppdaterad_av}</span>
            )}
          </span>
        </div>
      )}
    </div>
  );
}
